import { useState } from "react";
import { categories } from "@/mocks/categories";
import { CloudListing } from "@/mocks/cloudData";

interface CopyToSiteModalProps {
  selectedItems: CloudListing[];
  onClose: () => void;
  onConfirm: (targetCategoryId: string, targetCategoryName: string) => void;
}

export default function CopyToSiteModal({ selectedItems, onClose, onConfirm }: CopyToSiteModalProps) {
  const [selectedCat, setSelectedCat] = useState<string>("");
  const [searchCat, setSearchCat] = useState("");

  const filteredCats = categories.filter((c) =>
    c.name.toLowerCase().includes(searchCat.toLowerCase())
  );

  const handleConfirm = () => {
    if (!selectedCat) return;
    const cat = categories.find((c) => c.id === selectedCat);
    if (cat) onConfirm(selectedCat, cat.name);
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-md shadow-lg">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <div>
            <h3 className="text-base font-semibold text-gray-800">复制到网站分类</h3>
            <p className="text-xs text-gray-500 mt-0.5">已选 <span className="text-orange-500 font-medium">{selectedItems.length}</span> 条数据</p>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-400 cursor-pointer transition-colors"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>

        <div className="px-6 py-4">
          <p className="text-sm text-gray-600 mb-3">请选择要复制到的目标分类：</p>

          <div className="relative mb-3">
            <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
              <i className="ri-search-line text-gray-400 text-sm" />
            </div>
            <input
              type="text"
              placeholder="搜索分类..."
              value={searchCat}
              onChange={(e) => setSearchCat(e.target.value)}
              className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:border-orange-400 bg-gray-50"
            />
          </div>

          <div className="border border-gray-200 rounded-lg overflow-hidden max-h-52 overflow-y-auto">
            {filteredCats.length === 0 ? (
              <div className="py-8 text-center text-sm text-gray-400">未找到匹配分类</div>
            ) : (
              filteredCats.map((cat) => (
                <label
                  key={cat.id}
                  className={`flex items-center gap-3 px-4 py-3 cursor-pointer transition-colors border-b border-gray-50 last:border-0 ${
                    selectedCat === cat.id ? "bg-orange-50" : "hover:bg-gray-50"
                  }`}
                >
                  <input
                    type="radio"
                    name="target-category"
                    value={cat.id}
                    checked={selectedCat === cat.id}
                    onChange={() => setSelectedCat(cat.id)}
                    className="accent-orange-500"
                  />
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${cat.icon} text-sm ${selectedCat === cat.id ? "text-orange-500" : "text-gray-400"}`} />
                  </div>
                  <div className="flex-1">
                    <span className={`text-sm font-medium ${selectedCat === cat.id ? "text-orange-600" : "text-gray-700"}`}>
                      {cat.name}
                    </span>
                  </div>
                  <span className="text-xs text-gray-400">{cat.count} 条</span>
                </label>
              ))
            )}
          </div>
        </div>

        <div className="px-6 py-4 border-t border-gray-100 flex items-center justify-between">
          <div className="text-xs text-gray-400">
            <i className="ri-information-line mr-1" />
            数据将以草稿状态导入，需审核后发布
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              取消
            </button>
            <button
              onClick={handleConfirm}
              disabled={!selectedCat}
              className={`px-4 py-2 text-sm rounded-lg font-medium transition-colors whitespace-nowrap ${
                selectedCat
                  ? "bg-orange-500 text-white hover:bg-orange-600 cursor-pointer"
                  : "bg-gray-100 text-gray-400 cursor-not-allowed"
              }`}
            >
              确认复制
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
